/*external modules*/
/*types*/
/*utils*/
/*lib*/
/*other*/

enum HttpMethods {
  Get = 'get',
  Post = 'post',
  Put = 'put',
  Delete = 'delete'
}

export default HttpMethods;
